import {
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START,
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_COMPLETE,
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_ERROR,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_SUCCESS,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_ERROR,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_SUCCESS,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_ERROR
} from './action-types';

import createAdminsObject from '../utils/createAdminsObject';

const DEFAULT_STATE = {
  admins: {},
  fetchGrantRevokeEmrManagerRoleButtons: {
    shouldDisplay: false,
    loading: false,
    error: ''
  }
};

export const emrManagerReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START: {
      return {
        ...state,
        fetchGrantRevokeEmrManagerRoleButtons: {
          ...state.fetchGrantRevokeEmrManagerRoleButtons,
          loading: true
        }
      };
    }
    case FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_COMPLETE: {
      return {
        ...state,
        admins: createAdminsObject(action.payload.admins),
        fetchGrantRevokeEmrManagerRoleButtons: {
          ...state.fetchGrantRevokeEmrManagerRoleButtons,
          loading: false,
          shouldDisplay: action.payload.shouldDisplay
        }
      };
    }
    case FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_ERROR: {
      return {
        ...state,
        fetchGrantRevokeEmrManagerRoleButtons: {
          ...state.fetchGrantRevokeEmrManagerRoleButtons,
          loading: false,
          error: action.payload.error
        }
      };
    }
    case GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            grantEmrManagerRoleToAdmin: {
              ...state.admins[action.payload.adminId].grantEmrManagerRoleToAdmin,
              loading: true
            }
          }
        }
      };
    }
    case GRANT_EMR_MANAGER_ROLE_TO_ADMIN_SUCCESS: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            hasEmrManagerRole: true,
            grantEmrManagerRoleToAdmin: {
              ...state.admins[action.payload.adminId].grantEmrManagerRoleToAdmin,
              loading: false
            }
          }
        }
      };
    }
    case GRANT_EMR_MANAGER_ROLE_TO_ADMIN_ERROR: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            grantEmrManagerRoleToAdmin: {
              ...state.admins[action.payload.adminId].grantEmrManagerRoleToAdmin,
              loading: false,
              error: action.payload.error
            }
          }
        }
      };
    }
    case REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            revokeEmrManagerRoleFromAdmin: {
              ...state.admins[action.payload.adminId].revokeEmrManagerRoleFromAdmin,
              loading: true
            }
          }
        }
      };
    }
    case REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_SUCCESS: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            hasEmrManagerRole: false,
            revokeEmrManagerRoleFromAdmin: {
              ...state.admins[action.payload.adminId].revokeEmrManagerRoleFromAdmin,
              loading: false
            }
          }
        }
      };
    }
    case REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_ERROR: {
      return {
        ...state,
        admins: {
          ...state.admins,
          [action.payload.adminId]: {
            ...state.admins[action.payload.adminId],
            revokeEmrManagerRoleFromAdmin: {
              ...state.admins[action.payload.adminId].revokeEmrManagerRoleFromAdmin,
              loading: false,
              error: action.payload.error
            }
          }
        }
      };
    }
    default: {
      return state;
    }
  }
}
